import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import type { IntelSummary } from 'design-system';
import { useSearchParams } from 'react-router';

import { marketEventsOptions } from '../api/marketEvents.options';

/** Query param that carries the selected signal's id (see `MorningIntelPage`). */
export const SIGNAL_QUERY_PARAM = 'signal';

/**
 * Resolves the signal named by the `?signal=` query param against the fetched
 * signals list, wherever that param happens to be set — independent of which
 * route rendered it. Used by `AskGXDockedLayout` to show signal context in
 * the assistant panel without prop-drilling from the page.
 */
export const useSelectedSignal = (): IntelSummary | null => {
  const [searchParams] = useSearchParams();
  const signalId = searchParams.get(SIGNAL_QUERY_PARAM);
  const { data } = useQuery(marketEventsOptions.list());

  return useMemo(
    () => (signalId ? (data?.signals.find(signal => signal.id === signalId) ?? null) : null),
    [data, signalId]
  );
};
